import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom'; // Importar Link
import './SectionCuidatia.css';
import { BuscadorHome } from './BuscadorHome';

import banner1Image from './img/CuidatiaNuevo2026.png';
import banner2Image from './img/Ejes.png';

export const SectionCuidatia = (props = {}) => {
    const noop = () => {};

    const {
        Empresas = [],
        setEmpresas = noop,
        mapa = null,
        setMapa = noop,
        setModalUbiacion = noop,
        setEmpresasCargadas = noop,
        getEmpresas_preRegistradas = noop,
        limite = 0,
        setBuscarNombre = noop,
        setBuscarCategoria = noop,
        setBuscarLocalidad = noop,
        setBuscarProvincia = noop,
    } = props;

    // Creamos una referencia para almacenar los elementos del DOM (los banners)
    const bannersRef = useRef([]);

    // Función para añadir elementos al array de referencias
    const addToRefs = (el) => {
        if (el && !bannersRef.current.includes(el)) {
            bannersRef.current.push(el);
        }
    };

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    // Si el elemento entra en pantalla
                    if (entry.isIntersecting) {
                        // Añadimos la clase 'visible' que activa la animación CSS
                        entry.target.classList.add('visible');
                        // Dejamos de observar para que la animación solo ocurra una vez
                        observer.unobserve(entry.target);
                    }
                });
            },
            {
                threshold: 0.1, // Bajamos un poco el umbral para el banner grande
            }
        );

        // Observamos cada banner guardado en la referencia
        bannersRef.current.forEach((banner) => {
            if (banner) observer.observe(banner);
        });

        // Limpieza al desmontar el componente
        return () => {
            observer.disconnect();
        };
    }, []);

    return (
        <div className="cuidatia-section">
            
            {/* HERO BANNER: Cuidatia (Ancho completo) */}
<div ref={addToRefs} className="cuidatia-hero fade-in-up">
    <div className="cuidatia-hero-content">
        <img
            src={banner1Image}
            alt="Tecnología que cuida"
            className="hero-logo"
        />
    </div>
</div>

<div ref={addToRefs} className="cuidatia-banner slide-left">

    <div className="cuidatia-text-container cuidatia-presentacion">

        <h2>Cuidatia SaaS</h2>

        <p className="intro">
            Sistema digital de recolección y organización de datos de personas dependientes, para mejorar su calidad de vida
        </p>

        <strong>
            Toda la información de la persona, organizada en un único espacio.
        </strong>

        <img
            src={banner2Image}
            alt="Ecosistema Cuidatia"
            className="cuidatia-ecosistema"
        />

        <p className="descripcion">
            Cuidatia conecta la Historia de Vida, la Atención Centrada en la Persona,
            el hogar inteligente, la estimulación física y cognitiva y los servicios 
            de apoyo en una única plataforma digital.
        </p>

        <div className="cuidatia-actions">
    <a href="/cuidados" className="cuidatia-action-btn">
        Soy una familia
    </a>

    <a href="/proveedores" className="cuidatia-action-btn">
        Soy organización y/o administración
    </a>
</div>

    </div>

</div>

<div ref={addToRefs} className="cuidatia-process slide-left">

    <h2>¿Cómo funciona Cuidatia?</h2>

    <p className="process-subtitle">
        Cuidatia articula todo el proceso del cuidado en tres grandes ejes
        que trabajan de forma coordinada. No son aplicaciones independientes,
        ni módulos aislados. Son procesos permanentes que construyen,
        comparten y utilizan el conocimiento para mejorar la vida de las personas.
    </p>

    <div className="process-grid">

        {/* Eje 1 */}

        <div className="process-card">

            <span className="process-number">01</span>

            <h3>Conocer</h3>

            <h4>Conocer a la persona</h4>

            <strong>
                "Recogemos el conocimiento que realmente importa."
            </strong>

            <p>
                Todo comienza con la Historia de Vida, las preferencias,
                capacidades, relaciones y objetivos de la persona.
                Familia, profesionales y la propia persona construyen
                conjuntamente ese conocimiento mediante la Historia de Vida
                Social y el modelo ACP.
            </p>

        </div>

        {/* Eje 2 */}

        <div className="process-card">

            <span className="process-number">02</span>

            <h3>Conectar</h3>

            <h4>Compartir el conocimiento</h4>

            <strong>
                "Toda la información acompaña siempre a la persona."
            </strong>

            <p>
                Cuidatia sincroniza automáticamente la información entre
                domicilio, residencia, hospital, centro de día,
                profesionales y familia para que todos trabajen sobre
                una única Historia de Vida.
            </p>

        </div>

        {/* Eje 3 */}

        <div className="process-card">

            <span className="process-number">03</span>

            <h3>Impulsar</h3>

            <h4>Actuar para mejorar la calidad de vida</h4>

            <strong>
                "Convertimos el conocimiento en acciones."
            </strong>

            <p>
                El conocimiento se transforma en recursos digitales,
                prevención, seguimiento, comunicación y herramientas
                que mejoran la calidad de vida y enriquecen
                continuamente la Historia de Vida.
            </p>

        </div>

    </div>

    <div className="process-footer">

        <h3>Tres ejes. Un único objetivo.</h3>

        <p>
            Conocer · Conectar · Impulsar
        </p>

    </div>

</div>
            {/* Banner 2: Imagen Derecha, Texto Izquierda */}
            {/*<div ref={addToRefs} className="cuidatia-banner reverse slide-right">
                <div className="cuidatia-image-container">
                    <Link to="/cuidados">
                        <img src={banner2Image} alt="Cuidatia Cognitiva" className="cuidatia-image" />
                    </Link>
                </div>
                <div className="cuidatia-text-container">
                    <h2>Cuidados</h2>
                    <p>
                        Ayuda profesional cuando de verdad la necesitas. Cuidados verificados y de confianza,
                        a domicilio o en consulta, con reserva inmediata, horarios flexibles y seguimiento claro.
                        Para que cada necesidad tenga una respuesta rápida, segura y profundamente humana.
                    </p>
                    <strong>Cuidados que llegan cuando los necesitas.</strong>
                    <br />
                    <div className="cuidatia-search-card">
                        <BuscadorHome
                            Empresas={Empresas}
                            setEmpresas={setEmpresas}
                            mapa={mapa}
                            setMapa={setMapa}
                            setModalUbiacion={setModalUbiacion}
                            setEmpresasCargadas={setEmpresasCargadas}
                            getEmpresas_preRegistradas={getEmpresas_preRegistradas}
                            limite={limite}
                            setBuscarNombre={setBuscarNombre}
                            setBuscarCategoria={setBuscarCategoria}
                            setBuscarLocalidad={setBuscarLocalidad}
                            setBuscarProvincia={setBuscarProvincia}
                        />
                    </div>*/}
                                        {/* <a href="/cuidados" className="cuidatia-btn">Saber más</a> */}

                {/*</div>
                
            </div>*/}



            {/* Banner 3: Imagen Izquierda, Texto Derecha */}
            {/*<div ref={addToRefs} className="cuidatia-banner slide-left">
                <div className="cuidatia-image-container">
                    <a href="https://cuidatiacognitiva.adiper.es/" target="_blank" rel="noopener noreferrer">
                        <img src={banner3Image} alt="Cuidatia Cognitiva" className="cuidatia-image" />
                    </a>
                </div>
                <div className="cuidatia-text-container">
                    <h2>Cuidatia Cognitiva</h2>
                    <p>
                        Activa la mente y sostiene el ánimo. Juegos y rutinas accesibles que entrenan memoria,
                        atención y lenguaje, con niveles graduales, progreso visible y propuestas diarias que crean
                        hábito sin presión. Una experiencia cuidada para mantener la mente en marcha y la autoestima alta.
                    </p>
                    <strong>Pequeños retos, grandes beneficios.</strong>
                    <br />
                    <a
                        href="https://cuidatiacognitiva.adiper.es/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="cuidatia-btn"
                    >
                        Acceso a Cognitiva
                    </a>
                </div>
            </div>*/}

            {/* Banner 4: Imagen Derecha, Texto Izquierda */}
            {/*<div ref={addToRefs} className="cuidatia-banner reverse slide-right">
                <div className="cuidatia-image-container">
                    <a href="https://cuidatiavita.cuidatia.org/" target="_blank" rel="noopener noreferrer">
                        <img src={banner4Image} alt="Cuidatia Telemonitorización" className="cuidatia-image" />
                    </a>
                </div>
                <div className="cuidatia-text-container">
                    <h2>Teleasistencia Avanzada</h2>
                    <p>
                        Ayuda profesional cuando de 
                        verdad la necesitas. Cuidados 
                        verificados y de confianza, a 
                        domicilio o en consulta, con 
                        reserva inmediata, horarios 
                        flexibles y seguimiento claro. Para 
                        que cada necesidad tenga una 
                        respuesta rápida, segura y 
                        profundamente humana.
                    </p>
                    <strong>Seguimiento continuo, tranquilidad real.</strong>
                    <br />
                    <a 
                        href="https://cuidatiavita.cuidatia.org/" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="cuidatia-btn"
                    >
                        Acceso a Vita
                    </a>
                </div>
            </div>*/}
            
        </div>
    );
};